import apiSlice from "./ApiSlice";

const CategoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllCategoryData: builder.query({
      providesTags: ["category"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/category",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteCategoryById: builder.mutation({
      invalidatesTags: ["category"],
      query: (id: any) => ({
        url: `/category/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addCategory: builder.mutation({
      invalidatesTags: ["category"],
      query: (body) => ({
        url: `/category/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getCategoryById: builder.query({
      providesTags: ["category"],
      query: (id: string) => {
        return {
          url: `/category/${id}`,
          method: "GET",
        };
      },
    }),

    //get Payment Modes
    getAllCategory: builder.query({
      providesTags: ["category"],
      query: () => {
        return {
          url: `/category`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateCategoryById: builder.mutation({
      invalidatesTags: ["category"],
      query: ({ body, id }) => ({
        url: `/category/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusCategoryById: builder.mutation({
      invalidatesTags: ["category"],
      query: ({ body, id }) => ({
        url: `/category/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllCategoryDataQuery,
  useDeleteCategoryByIdMutation,
  useAddCategoryMutation,
  useGetCategoryByIdQuery,
  useUpdateCategoryByIdMutation,
  useGetAllCategoryQuery,
  useChangeStatusCategoryByIdMutation,
} = CategoryApi;
